import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { postEasterEggFound } from 'redux/thunks';

export function useEasterEggFound(eggId: string) {
	const dispatch = useDispatch();
	const userEggState = useSelector((state: RootStore) => state.EasterEgg.userEggs);
	return () => {
		const eggFoundIndex = userEggState.findIndex(x => x.eggId === eggId);
		if (eggFoundIndex === -1) {
			dispatch(postEasterEggFound(eggId));
		}
	};
}
